<template>
  <div>
    <div class="vca-right">
      <vca-row>
        <div>
          <button
            :title="$t('button.edit')"
            class="vca-new-button"
            @click="setCurrentEdit(event)"
            v-if="editable"
          >
            {{ $t("button.edit") }}
          </button>
        </div>
        <div v-if="showApplication && event.isPublished">
          <button
            :title="$t('button.participations')"
            class="vca-new-button"
            @click="setCurrentParticipation(event)"
          >
            {{ $t("button.participations") }}
          </button>
        </div>
        <div v-if="event.isPublished">
          <button
            @click="setCurrentEmail(event)"
            :title="$t('context_button.send', { 0: $t('email.label') })"
            class="vca-new-button"
          >
            {{ $t("context_button.send", { 0: $t("email.label") }) }}
          </button>
        </div>
      </vca-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EventApplicationManage",
  props: {
    event: {
      type: Object,
      default: null,
    },
    showApplication: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      user: "user/current",
    }),
  },
  methods: {
    isEventAsp(value) {
      return (
        this.user && value.event_asp_id && this.user.id == value.event_asp_id
      );
    },
    setCurrentEdit(value) {
      this.$router.push({ path: "/events/edit/" + value.id });
    },
    setCurrentParticipation(value) {
      this.$router.push({ path: "/events/participants/" + value.id });
    },
    setCurrentEmail(event) {
      if (this.isEventAsp(event)) {
        this.$store.commit("user/emails/mailbox/message/create_event", event);
        this.$router.push({ path: "/account/asps/emails/create" });
      } else {
        this.$store.commit("emails/mailbox/message/create_event", event);
        this.$router.push({ path: "/emails/create" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vca-right {
  justify-content: flex-start;

  @include media(large) {
    justify-content: flex-end;
  }
}

.vca-new-button {
  margin: 0;
  margin-bottom: 12px;

  @include media(large) {
    margin-left: 16px;
  }
}
</style>
